import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=35244958&scoped=true&"
import script from "./editform.vue?vue&type=script&lang=js&"
export * from "./editform.vue?vue&type=script&lang=js&"
import style0 from "./editform.vue?vue&type=style&index=0&id=35244958&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35244958",
  null
  
)

export default component.exports